import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

export interface PeriodicElement {
 
  Name: string;
  Date: string;
  Day: string;
  Considaration: string;
  Notes: string;
  Status: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {Name: 'Anjali Patel', Date: '11-May', Day: 'Wednesday', Status: '', Considaration: '-', Notes: ''},
  {Name: 'Vivek Chhatbar' , Date: '11-May', Day:'Wednesday', Status: '',Considaration: '-', Notes: ''},
  {Name: 'Anwesha ', Date: '11-May', Day: 'Wednesday',Status: '',Considaration: '-', Notes: ''},
  {Name: 'Sahil Patel' , Date: '11-May', Day: 'Wednesday', Status: '',Considaration: 'Holiday', Notes: ''},
];

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements OnInit {

  fromDate: any = new Date(new Date());

  displayedColumns: string[] = ['Name', 'Date', 'Day', 'Status', 'Considaration', 'Notes'];
  dataSource = ELEMENT_DATA;

  constructor() { }

  ngOnInit(): void {
  }


}
